<template>
  <v-layout>
    <filtersMaster ref="filtersMaster" :select="select" :filtersdef="filtros" :options="options" @filter="filter" @loadSelectsData="loadSelectsData" @loadSelectProvincia="loadSelectProvincia" />
    <v-layout column right floating class="fab-container" style="z-index: 1">
      <v-btn color="primary" fab small dark :title="$t('view.commons.report')" :loading="view.action.submit.busy" class="btn_tippy_menu" @click="report">
        <v-icon small>fas fa-file-excel</v-icon>
      </v-btn>
    </v-layout>
  </v-layout>
</template>
<script>
import FiltersMaster from "@/components/datatable/Filters"; /** *******************************/
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";
import { STATUS_FORMULARIO_SELECT_REPORTE_VISITAS } from "@/constants/bases";

export default {
  name: "FiltersModule"
  , components: { FiltersMaster }
  , data() {
    return {
      init: true
      , view: { action: { submit: { busy: false } } }
      , select: {
        vendor: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , rep: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , status: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , substatus: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , provincia: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , estatus: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
      }
      , filtros: {
        fecha: []
        , vendor: []
        , rep: []
        , status: []
        , substatus: []
        , provincia: []
        , estatus: []
        , exclusion: []
        , oob: []
      }
      , options: [
        {
          code: "fecha"
          , name: this.$t("view.reportes.reportevisitas.filters.fecha")
          , icon: "fas fa-calendar-check"
          , type: "date"
          , selected: { ini: "", end: "" }
          , disabled: false
        }
        , {
          code: "vendor"
          , name: this.$t("view.reportes.reportevisitas.filters.vendor")
          , icon: "fas fa-hand-holding-usd"
          , type: "select"
          , selected: {}
          , disabled: this.$store.getters.getUserData.tipoUsuario != "ADMINISTRADOR"
        }
        , {
          code: "rep"
          , name: this.$t("view.reportes.reportevisitas.filters.rep")
          , icon: "fas fa-file-invoice-dollar"
          , type: "select"
          , selected: {}
          , disabled: !(this.$store.getters.getUserData.tipoUsuario == "ADMINISTRADOR" || this.$store.getters.getUserData.tipoUsuario == "VENDOR")
        }
        , {
          code: "status"
          , name: this.$t("view.reportes.reportevisitas.filters.status")
          , icon: "fas fa-check"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "substatus"
          , name: this.$t("view.reportes.reportevisitas.filters.substatus")
          , icon: "fas fa-check-double"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "provincia"
          , name: this.$t("view.reportes.reportevisitas.filters.provincia")
          , icon: "fas fa-map"
          , type: "serverside"
          , selected: {}
          , disabled: false
        }
        , {
          code: "estatus"
          , name: this.$t("view.reportes.reportevisitas.filters.estatus")
          , icon: "fas fa-check-double"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "exclusion"
          , name: this.$t("view.reportes.reportevisitas.filters.exclusion")
          , icon: "fas fa-times"
          , type: "sino"
          , selected: true
          , disabled: false
        }
        , {
          code: "oob"
          , name: this.$t("view.reportes.reportevisitas.filters.oob")
          , icon: "fas fa-sign-out-alt"
          , type: "sino"
          , selected: true
          , disabled: false
        }
      ]
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, size: "large", animation: "scale", placement: "left" }));
  }
  , methods: {
    filter(filtros) {
      this.$emit("filter", filtros);
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
    , async loadSelectsData() {
      if (this.init) {
        this.loadSelectVendor();
        this.loadSelectRep();
        this.loadSelectStatus();
        this.loadSelectSubStatus();
        this.loadSelectEstatus();

        if (this.select.estatus.filteredList.length > 0) this.init = false;
      }
    }
    , async loadSelectVendor() {
      const { data: { results: { combo: vendorList } } } = await CombosAPI.get({ option: "vendor" });
      this.select.vendor.filteredList = vendorList || [];
      this.select.vendor.completeList = vendorList || [];
    }
    , async loadSelectRep() {
      const tipoUsuario = this.$store.getters.getUserData.tipoUsuario;
      const idVendor = this.$store.getters.getUserData.idVendor;
      const { data: { results: { combo: repList } } } = tipoUsuario == "VENDOR" ? await CombosAPI.getByParameter({ option: "repsPorVendor", parameter: idVendor }) : await CombosAPI.get({ option: "rep" });
      this.select.rep.filteredList = repList || [];
      this.select.rep.completeList = repList || [];
    }
    , async loadSelectStatus() {
      const { data: { results: { combo: statusList } } } = await CombosAPI.get({ option: "status" });
      this.select.status.filteredList = statusList || [];
      this.select.status.completeList = statusList || [];
    }
    , async loadSelectSubStatus() {
      const { data: { results: { combo: substatusList } } } = await CombosAPI.get({ option: "substatus" });
      this.select.substatus.filteredList = substatusList || [];
      this.select.substatus.completeList = substatusList || [];
    }
    , async loadSelectProvincia(selected, value) {
      const { data: { results: { combo: provinciaList } } } = await CombosAPI.getSeverSide({ option: "ssprovincia", keyword: value });
      this.select[selected].filteredList = [...this.select[selected].filteredList, ...(provinciaList || [])];
      this.select[selected].completeList = [...this.select[selected].completeList, ...(provinciaList || [])];
    }
    , async loadSelectEstatus() {
      this.select.estatus.filteredList = STATUS_FORMULARIO_SELECT_REPORTE_VISITAS || [];
      this.select.estatus.completeList = STATUS_FORMULARIO_SELECT_REPORTE_VISITAS || [];
    }
    , report() {
      this.$emit("report");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fab-container {
  position: fixed;
  top: 110px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/reportes/reportevisitas/Filters.vue